import { EventNames, EventDetails, DMCustomEvent } from '../types';

const createCustomEvent = <T extends keyof EventDetails>(eventName: T, detail: EventDetails[T]) =>
  new CustomEvent<EventDetails[T]>(eventName, { detail });

/**
 * When delta-matrix's mount function is called from its consumers (eg. ua-web-sdk) and some of the arguments are changed.
 * (eg. copilot chat open state, or pageInputs). We need to emit custom events to set the local states correctly and honour these settings, as not all arguments
 * are reactive.
 * For eg. We have a local state for open state of copilot chat. When the sdk's mount function is called with a new open state, we need to emit a custom event
 * to update the local state.
 *
 * Question - Why not useEffect?
 * Answer - useEffect can not be used here because mount function can be called with exactly same arguments multiple times,
 *          useEffect will not be called in this case, but we want to handle the event and make updates everytime.
 *          OR, as our external settings passed to mount function are out of react flow useEffect won't work correctly here.
 */
export const emitCustomEvents = (customEvent: DMCustomEvent) => {
  const { event, props } = customEvent;

  switch (event) {
    case EventNames.SetChatVisibility: {
      const { open } = props;
      window.dispatchEvent(createCustomEvent(EventNames.SetChatVisibility, { open }));
      break;
    }
    case EventNames.GoToPage: {
      const { pageId, pageInputs } = props;
      if (pageId || pageInputs) {
        window.dispatchEvent(createCustomEvent(EventNames.GoToPage, { pageId, pageInputs }));
        // If page is updated then we dispatch SetChatVisibility event also so that if application type is copilot chat then chat is opened
        window.dispatchEvent(createCustomEvent(EventNames.SetChatVisibility, { open: true }));
      }

      break;
    }
  }
};
